// extracted by mini-css-extract-plugin
module.exports = {"container":"navbar_container__3Bp_L","eventNumber":"navbar_eventNumber__dr3Kf","organisation":"navbar_organisation__2YGsP"};